<template>
    <date-picker v-model="internalModel" :disabled-dates="disabledDates" :label="label" class="limitedDatePicker">
    </date-picker>
</template>

<script>
import DatePicker from './DatePicker';

const BEGIN_OF_CARSHARING_TIME = new Date(2015, 2, 15); // 2015-03-15 (month is zero-based)

export default {
    name: 'LimitedDatePicker',

    components: {
        DatePicker
    },

    model: {
        prop: 'externalModel'
    },

    props: {
        externalModel: {
            type: Date,
            required: true
        },
        label: {
            type: String,
            default: ''
        },
        syncRequireBefore: {
            type: Date,
            default: () => new Date()
        },
        syncRequireAfter: {
            type: Date,
            default: () => new Date(BEGIN_OF_CARSHARING_TIME)
        }
    },

    computed: {
        disabledDates() {
            return {
                to: new Date(Math.max(this.syncRequireAfter, BEGIN_OF_CARSHARING_TIME)),
                from: new Date(Math.min(this.syncRequireBefore, new Date()))
            };
        },

        internalModel: {
            get() {
                return this.externalModel;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    }
};
</script>
